var map = {
	"./Angles_Class_II_Division_I/Angle's_Class_II_Division_I_prew.png": 264258,
	"./Angles_Class_II_Division_I/img/1.png": 423027,
	"./Angles_Class_II_Division_I/img/10.png": 570668,
	"./Angles_Class_II_Division_I/img/11.png": 981877,
	"./Angles_Class_II_Division_I/img/12.png": 180556,
	"./Angles_Class_II_Division_I/img/13.png": 403796,
	"./Angles_Class_II_Division_I/img/14.png": 544825,
	"./Angles_Class_II_Division_I/img/15.png": 698720,
	"./Angles_Class_II_Division_I/img/16.png": 620721,
	"./Angles_Class_II_Division_I/img/17.png": 533740,
	"./Angles_Class_II_Division_I/img/18.png": 58762,
	"./Angles_Class_II_Division_I/img/19.png": 875490,
	"./Angles_Class_II_Division_I/img/2.png": 713365,
	"./Angles_Class_II_Division_I/img/20.png": 47295,
	"./Angles_Class_II_Division_I/img/21.png": 435276,
	"./Angles_Class_II_Division_I/img/3.png": 287614,
	"./Angles_Class_II_Division_I/img/4.png": 611338,
	"./Angles_Class_II_Division_I/img/5.png": 202025,
	"./Angles_Class_II_Division_I/img/6.png": 409984,
	"./Angles_Class_II_Division_I/img/7.png": 213055,
	"./Angles_Class_II_Division_I/img/8.png": 156244,
	"./Angles_Class_II_Division_I/img/9.png": 979136,
	"./Angles_Class_II_Division_II/Angle's_Class_II_Division_II_prew.png": 671209,
	"./Angles_Class_II_Division_II/img/1.png": 894578,
	"./Angles_Class_II_Division_II/img/10.png": 172957,
	"./Angles_Class_II_Division_II/img/11.png": 370436,
	"./Angles_Class_II_Division_II/img/12.png": 646366,
	"./Angles_Class_II_Division_II/img/13.png": 138791,
	"./Angles_Class_II_Division_II/img/14.png": 413586,
	"./Angles_Class_II_Division_II/img/15.png": 698971,
	"./Angles_Class_II_Division_II/img/16.png": 405086,
	"./Angles_Class_II_Division_II/img/17.png": 251343,
	"./Angles_Class_II_Division_II/img/18.png": 295327,
	"./Angles_Class_II_Division_II/img/19.png": 839329,
	"./Angles_Class_II_Division_II/img/2.png": 563979,
	"./Angles_Class_II_Division_II/img/20.png": 457197,
	"./Angles_Class_II_Division_II/img/3.png": 749628,
	"./Angles_Class_II_Division_II/img/4.png": 661401,
	"./Angles_Class_II_Division_II/img/5.png": 190181,
	"./Angles_Class_II_Division_II/img/6.png": 539603,
	"./Angles_Class_II_Division_II/img/7.png": 700951,
	"./Angles_Class_II_Division_II/img/8.png": 769590,
	"./Angles_Class_II_Division_II/img/9.png": 163025,
	"./Cross_bite/Cross_bite_prew.png": 656401,
	"./Cross_bite/img/1.png": 989955,
	"./Cross_bite/img/10.png": 109536,
	"./Cross_bite/img/11.png": 900277,
	"./Cross_bite/img/12.png": 615500,
	"./Cross_bite/img/13.png": 355403,
	"./Cross_bite/img/2.png": 816978,
	"./Cross_bite/img/3.png": 473110,
	"./Cross_bite/img/4.png": 300429,
	"./Cross_bite/img/5.png": 698070,
	"./Cross_bite/img/6.png": 445518,
	"./Cross_bite/img/7.png": 340675,
	"./Cross_bite/img/8.png": 923211,
	"./Cross_bite/img/9.png": 7160,
	"./Crowding_of_teeth_on_both_jaws/Crowding_of_teeth_on_both_jaws_prew.png": 392405,
	"./Crowding_of_teeth_on_both_jaws/img/1.png": 515095,
	"./Crowding_of_teeth_on_both_jaws/img/10.png": 170918,
	"./Crowding_of_teeth_on_both_jaws/img/11.png": 310924,
	"./Crowding_of_teeth_on_both_jaws/img/12.png": 920409,
	"./Crowding_of_teeth_on_both_jaws/img/13.png": 828022,
	"./Crowding_of_teeth_on_both_jaws/img/14.png": 943175,
	"./Crowding_of_teeth_on_both_jaws/img/15.png": 439073,
	"./Crowding_of_teeth_on_both_jaws/img/2.png": 663606,
	"./Crowding_of_teeth_on_both_jaws/img/3.png": 436908,
	"./Crowding_of_teeth_on_both_jaws/img/4.png": 313984,
	"./Crowding_of_teeth_on_both_jaws/img/5.png": 23499,
	"./Crowding_of_teeth_on_both_jaws/img/6.png": 842480,
	"./Crowding_of_teeth_on_both_jaws/img/7.png": 173644,
	"./Crowding_of_teeth_on_both_jaws/img/8.png": 574107,
	"./Crowding_of_teeth_on_both_jaws/img/9.png": 629043,
	"./Crowding_of_teeth_on_one_jaw/Crowding_of_teeth_on_one_jaw_prew.png": 728981,
	"./Crowding_of_teeth_on_one_jaw/img/1.png": 776078,
	"./Crowding_of_teeth_on_one_jaw/img/10.png": 429999,
	"./Crowding_of_teeth_on_one_jaw/img/11.png": 704722,
	"./Crowding_of_teeth_on_one_jaw/img/12.png": 435465,
	"./Crowding_of_teeth_on_one_jaw/img/13.png": 601225,
	"./Crowding_of_teeth_on_one_jaw/img/14.png": 524170,
	"./Crowding_of_teeth_on_one_jaw/img/2.png": 306922,
	"./Crowding_of_teeth_on_one_jaw/img/3.png": 702165,
	"./Crowding_of_teeth_on_one_jaw/img/4.png": 48517,
	"./Crowding_of_teeth_on_one_jaw/img/5.png": 142867,
	"./Crowding_of_teeth_on_one_jaw/img/6.png": 575496,
	"./Crowding_of_teeth_on_one_jaw/img/7.png": 567565,
	"./Crowding_of_teeth_on_one_jaw/img/8.png": 132023,
	"./Crowding_of_teeth_on_one_jaw/img/9.png": 280892,
	"./Expansion_of_dental_arches/Expansion_of_dental_arches_prew.png": 753670,
	"./Expansion_of_dental_arches/img/1.png": 552825,
	"./Expansion_of_dental_arches/img/10.png": 460959,
	"./Expansion_of_dental_arches/img/11.png": 339239,
	"./Expansion_of_dental_arches/img/12.png": 167133,
	"./Expansion_of_dental_arches/img/13.png": 634076,
	"./Expansion_of_dental_arches/img/14.png": 702924,
	"./Expansion_of_dental_arches/img/15.png": 392437,
	"./Expansion_of_dental_arches/img/2.png": 875736,
	"./Expansion_of_dental_arches/img/3.png": 553865,
	"./Expansion_of_dental_arches/img/4.png": 748301,
	"./Expansion_of_dental_arches/img/5.png": 575093,
	"./Expansion_of_dental_arches/img/6.png": 502264,
	"./Expansion_of_dental_arches/img/7.png": 573959,
	"./Expansion_of_dental_arches/img/8.png": 750418,
	"./Expansion_of_dental_arches/img/9.png": 415449,
	"./Extruded_tooth/Extruded_tooth_prew.png": 29491,
	"./Extruded_tooth/img/1.png": 20723,
	"./Extruded_tooth/img/10.png": 132111,
	"./Extruded_tooth/img/11.png": 529767,
	"./Extruded_tooth/img/12.png": 226969,
	"./Extruded_tooth/img/13.png": 347979,
	"./Extruded_tooth/img/2.png": 126660,
	"./Extruded_tooth/img/3.png": 408028,
	"./Extruded_tooth/img/4.png": 746240,
	"./Extruded_tooth/img/5.png": 207733,
	"./Extruded_tooth/img/6.png": 312077,
	"./Extruded_tooth/img/7.png": 332981,
	"./Extruded_tooth/img/8.png": 886197,
	"./Extruded_tooth/img/9.png": 92161,
	"./Incorrect_inclination_of_the_tooth/Incorrect_inclination_of_the_tooth_prew.png": 85373,
	"./Incorrect_inclination_of_the_tooth/img/1.png": 450004,
	"./Incorrect_inclination_of_the_tooth/img/10.png": 571079,
	"./Incorrect_inclination_of_the_tooth/img/11.png": 290041,
	"./Incorrect_inclination_of_the_tooth/img/12.png": 14252,
	"./Incorrect_inclination_of_the_tooth/img/13.png": 307607,
	"./Incorrect_inclination_of_the_tooth/img/2.png": 315807,
	"./Incorrect_inclination_of_the_tooth/img/3.png": 514901,
	"./Incorrect_inclination_of_the_tooth/img/4.png": 85008,
	"./Incorrect_inclination_of_the_tooth/img/5.png": 790510,
	"./Incorrect_inclination_of_the_tooth/img/6.png": 849561,
	"./Incorrect_inclination_of_the_tooth/img/7.png": 10355,
	"./Incorrect_inclination_of_the_tooth/img/8.png": 649505,
	"./Incorrect_inclination_of_the_tooth/img/9.png": 89474,
	"./Intruded_tooth/Intruded_tooth_prew.png": 483277,
	"./Intruded_tooth/img/1.png": 716869,
	"./Intruded_tooth/img/10.png": 664632,
	"./Intruded_tooth/img/11.png": 927939,
	"./Intruded_tooth/img/12.png": 323771,
	"./Intruded_tooth/img/13.png": 99583,
	"./Intruded_tooth/img/2.png": 399543,
	"./Intruded_tooth/img/3.png": 407438,
	"./Intruded_tooth/img/4.png": 483146,
	"./Intruded_tooth/img/5.png": 595202,
	"./Intruded_tooth/img/6.png": 48659,
	"./Intruded_tooth/img/7.png": 445516,
	"./Intruded_tooth/img/8.png": 999233,
	"./Intruded_tooth/img/9.png": 502005,
	"./One_side_Angles_Class_II/One_side_Angle's_Class_II_prew.png": 25202,
	"./One_side_Angles_Class_II/img/1.png": 960385,
	"./One_side_Angles_Class_II/img/10.png": 186725,
	"./One_side_Angles_Class_II/img/11.png": 859824,
	"./One_side_Angles_Class_II/img/12.png": 758432,
	"./One_side_Angles_Class_II/img/13.png": 847207,
	"./One_side_Angles_Class_II/img/14.png": 190751,
	"./One_side_Angles_Class_II/img/15.png": 402325,
	"./One_side_Angles_Class_II/img/2.png": 233841,
	"./One_side_Angles_Class_II/img/3.png": 948255,
	"./One_side_Angles_Class_II/img/4.png": 286763,
	"./One_side_Angles_Class_II/img/5.png": 132182,
	"./One_side_Angles_Class_II/img/6.png": 495545,
	"./One_side_Angles_Class_II/img/7.png": 129458,
	"./One_side_Angles_Class_II/img/8.png": 541554,
	"./One_side_Angles_Class_II/img/9.png": 92034,
	"./One_side_Angles_Class_III/One_side_Angle's_Class_III_prew.png": 492574,
	"./One_side_Angles_Class_III/img/1.png": 258956,
	"./One_side_Angles_Class_III/img/10.png": 799632,
	"./One_side_Angles_Class_III/img/11.png": 51646,
	"./One_side_Angles_Class_III/img/12.png": 783348,
	"./One_side_Angles_Class_III/img/13.png": 829189,
	"./One_side_Angles_Class_III/img/14.png": 252492,
	"./One_side_Angles_Class_III/img/15.png": 147570,
	"./One_side_Angles_Class_III/img/2.png": 689601,
	"./One_side_Angles_Class_III/img/3.png": 392233,
	"./One_side_Angles_Class_III/img/4.png": 77519,
	"./One_side_Angles_Class_III/img/5.png": 259664,
	"./One_side_Angles_Class_III/img/6.png": 639896,
	"./One_side_Angles_Class_III/img/7.png": 295461,
	"./One_side_Angles_Class_III/img/8.png": 397563,
	"./One_side_Angles_Class_III/img/9.png": 773483,
	"./Openbite/Openbite_prew.png": 734983,
	"./Openbite/img/1.png": 926050,
	"./Openbite/img/10.png": 977257,
	"./Openbite/img/11.png": 488927,
	"./Openbite/img/12.png": 156466,
	"./Openbite/img/13.png": 978856,
	"./Openbite/img/14.png": 550022,
	"./Openbite/img/15.png": 795131,
	"./Openbite/img/16.png": 880808,
	"./Openbite/img/2.png": 66229,
	"./Openbite/img/3.png": 223397,
	"./Openbite/img/4.png": 715313,
	"./Openbite/img/5.png": 649783,
	"./Openbite/img/6.png": 109614,
	"./Openbite/img/7.png": 441722,
	"./Openbite/img/8.png": 125661,
	"./Openbite/img/9.png": 534891,
	"./Overbite_deep_bite/Overbite_deep_bite_prew.png": 586526,
	"./Overbite_deep_bite/img/1.png": 823226,
	"./Overbite_deep_bite/img/10.png": 395609,
	"./Overbite_deep_bite/img/11.png": 304686,
	"./Overbite_deep_bite/img/12.png": 978681,
	"./Overbite_deep_bite/img/13.png": 848,
	"./Overbite_deep_bite/img/2.png": 422446,
	"./Overbite_deep_bite/img/3.png": 189373,
	"./Overbite_deep_bite/img/4.png": 701551,
	"./Overbite_deep_bite/img/5.png": 55465,
	"./Overbite_deep_bite/img/6.png": 459425,
	"./Overbite_deep_bite/img/7.png": 126739,
	"./Overbite_deep_bite/img/8.png": 585275,
	"./Overbite_deep_bite/img/9.png": 570271,
	"./Overjet_sagittal_fissure/Overjet_sagittal_fissure_prew.png": 866078,
	"./Overjet_sagittal_fissure/img/1.png": 49015,
	"./Overjet_sagittal_fissure/img/10.png": 309211,
	"./Overjet_sagittal_fissure/img/11.png": 469815,
	"./Overjet_sagittal_fissure/img/12.png": 603015,
	"./Overjet_sagittal_fissure/img/13.png": 689444,
	"./Overjet_sagittal_fissure/img/14.png": 34673,
	"./Overjet_sagittal_fissure/img/15.png": 484892,
	"./Overjet_sagittal_fissure/img/2.png": 286789,
	"./Overjet_sagittal_fissure/img/3.png": 73021,
	"./Overjet_sagittal_fissure/img/4.png": 253715,
	"./Overjet_sagittal_fissure/img/5.png": 858441,
	"./Overjet_sagittal_fissure/img/6.png": 810873,
	"./Overjet_sagittal_fissure/img/7.png": 260018,
	"./Overjet_sagittal_fissure/img/8.png": 369114,
	"./Overjet_sagittal_fissure/img/9.png": 456067,
	"./Protrusion_of_the_anterior_teeth/Protrusion_of_the_anterior_teeth_prew.png": 904512,
	"./Protrusion_of_the_anterior_teeth/img/1.png": 626486,
	"./Protrusion_of_the_anterior_teeth/img/10.png": 182973,
	"./Protrusion_of_the_anterior_teeth/img/11.png": 438953,
	"./Protrusion_of_the_anterior_teeth/img/12.png": 92480,
	"./Protrusion_of_the_anterior_teeth/img/13.png": 159135,
	"./Protrusion_of_the_anterior_teeth/img/14.png": 665553,
	"./Protrusion_of_the_anterior_teeth/img/2.png": 723842,
	"./Protrusion_of_the_anterior_teeth/img/3.png": 660557,
	"./Protrusion_of_the_anterior_teeth/img/4.png": 303600,
	"./Protrusion_of_the_anterior_teeth/img/5.png": 342951,
	"./Protrusion_of_the_anterior_teeth/img/6.png": 27154,
	"./Protrusion_of_the_anterior_teeth/img/7.png": 955974,
	"./Protrusion_of_the_anterior_teeth/img/8.png": 116380,
	"./Protrusion_of_the_anterior_teeth/img/9.png": 481515,
	"./Retrusion_of_the_anterior_teeth/Retrusion_of_the_anterior_teeth_prew.png": 329137,
	"./Retrusion_of_the_anterior_teeth/img/1.png": 406546,
	"./Retrusion_of_the_anterior_teeth/img/10.png": 625387,
	"./Retrusion_of_the_anterior_teeth/img/11.png": 168262,
	"./Retrusion_of_the_anterior_teeth/img/12.png": 429678,
	"./Retrusion_of_the_anterior_teeth/img/13.png": 149287,
	"./Retrusion_of_the_anterior_teeth/img/14.png": 393314,
	"./Retrusion_of_the_anterior_teeth/img/15.png": 352964,
	"./Retrusion_of_the_anterior_teeth/img/2.png": 74809,
	"./Retrusion_of_the_anterior_teeth/img/3.png": 361443,
	"./Retrusion_of_the_anterior_teeth/img/4.png": 155926,
	"./Retrusion_of_the_anterior_teeth/img/5.png": 440904,
	"./Retrusion_of_the_anterior_teeth/img/6.png": 151500,
	"./Retrusion_of_the_anterior_teeth/img/7.png": 925865,
	"./Retrusion_of_the_anterior_teeth/img/8.png": 480327,
	"./Retrusion_of_the_anterior_teeth/img/9.png": 688269,
	"./Rotated_tooth/Rotated_tooth_prew.png": 229448,
	"./Rotated_tooth/img/1.png": 927485,
	"./Rotated_tooth/img/10.png": 898451,
	"./Rotated_tooth/img/11.png": 213372,
	"./Rotated_tooth/img/12.png": 644861,
	"./Rotated_tooth/img/13.png": 632128,
	"./Rotated_tooth/img/14.png": 175513,
	"./Rotated_tooth/img/2.png": 516200,
	"./Rotated_tooth/img/3.png": 135216,
	"./Rotated_tooth/img/4.png": 969347,
	"./Rotated_tooth/img/5.png": 155227,
	"./Rotated_tooth/img/6.png": 61845,
	"./Rotated_tooth/img/7.png": 230038,
	"./Rotated_tooth/img/8.png": 815166,
	"./Rotated_tooth/img/9.png": 514314,
	"./Small_multiple_violations/Small_multiple_violations_prew.png": 311747,
	"./Small_multiple_violations/img/1.png": 125087,
	"./Small_multiple_violations/img/10.png": 242083,
	"./Small_multiple_violations/img/11.png": 538369,
	"./Small_multiple_violations/img/12.png": 205346,
	"./Small_multiple_violations/img/13.png": 290651,
	"./Small_multiple_violations/img/14.png": 541342,
	"./Small_multiple_violations/img/2.png": 114176,
	"./Small_multiple_violations/img/3.png": 740610,
	"./Small_multiple_violations/img/4.png": 578992,
	"./Small_multiple_violations/img/5.png": 495285,
	"./Small_multiple_violations/img/6.png": 339288,
	"./Small_multiple_violations/img/7.png": 37650,
	"./Small_multiple_violations/img/8.png": 510071,
	"./Small_multiple_violations/img/9.png": 141015,
	"./Spacing/Spacing_prew.png": 483865,
	"./Spacing/img/1.png": 693838,
	"./Spacing/img/10.png": 145008,
	"./Spacing/img/11.png": 304200,
	"./Spacing/img/12.png": 630468,
	"./Spacing/img/13.png": 204711,
	"./Spacing/img/14.png": 833829,
	"./Spacing/img/2.png": 983847,
	"./Spacing/img/3.png": 566817,
	"./Spacing/img/4.png": 513630,
	"./Spacing/img/5.png": 585770,
	"./Spacing/img/6.png": 44652,
	"./Spacing/img/7.png": 978743,
	"./Spacing/img/8.png": 619267,
	"./Spacing/img/9.png": 457607,
	"./Violation_tooth_angulation/Violation_tooth_angulation_prew.png": 16554,
	"./Violation_tooth_angulation/img/1.png": 981574,
	"./Violation_tooth_angulation/img/10.png": 105310,
	"./Violation_tooth_angulation/img/11.png": 237777,
	"./Violation_tooth_angulation/img/12.png": 150709,
	"./Violation_tooth_angulation/img/13.png": 232367,
	"./Violation_tooth_angulation/img/2.png": 408542,
	"./Violation_tooth_angulation/img/3.png": 969152,
	"./Violation_tooth_angulation/img/4.png": 576303,
	"./Violation_tooth_angulation/img/5.png": 764803,
	"./Violation_tooth_angulation/img/6.png": 470475,
	"./Violation_tooth_angulation/img/7.png": 658627,
	"./Violation_tooth_angulation/img/8.png": 600910,
	"./Violation_tooth_angulation/img/9.png": 184798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984934;